import React, { useState, useCallback, useEffect } from "react";
import toast from "react-hot-toast";
import { Spinner } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import Backend from "../../../Backend/Backend";

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

  .rg {
    min-height: 100vh;
    display: flex; align-items: center; justify-content: center;
    background: var(--background);
    padding: 12px; font-family: 'Inter', sans-serif; box-sizing: border-box;
  }

  .rg-box {
    background: var(--background);
    border: 1px solid var(--hover);
    border-radius: 16px;
    padding: 28px 24px 22px;
    width: 100%; max-width: 380px;
    box-shadow: 0 4px 24px rgba(0,0,0,.08);
  }

  .rg-head { text-align: center; margin-bottom: 18px; }
  .rg-head img { width: 48px; height: 48px; object-fit: contain; margin-bottom: 10px; }
  .rg-head h2 { margin: 0; font-size: 17px; font-weight: 600; color: var(--text); }
  .rg-head p  { margin: 3px 0 0; font-size: 12px; color: var(--subtext); }

  .rg-steps { display: flex; gap: 6px; justify-content: center; margin-bottom: 16px; }
  .rg-dot { width: 28px; height: 3px; border-radius: 2px; background: var(--hover); }
  .rg-dot.on { background: var(--primary); }

  .rg-label {
    display: block; font-size: 11px; font-weight: 500;
    color: var(--subtext); margin-bottom: 5px;
    text-transform: uppercase; letter-spacing: .5px;
  }

  .rg-input {
    width: 100%; height: 42px; padding: 0 12px;
    border: 1px solid var(--hover);
    border-radius: 10px;
    font-size: 13px; color: var(--text);
    background: var(--background);
    outline: none; box-sizing: border-box;
    transition: border-color .18s, background .18s;
    font-family: 'Inter', sans-serif;
    -moz-appearance: textfield;
  }
  .rg-input::-webkit-outer-spin-button,
  .rg-input::-webkit-inner-spin-button { -webkit-appearance: none; }
  .rg-input:focus { border-color: var(--primary); background: var(--background); }
  .rg-input::placeholder { color: var(--subtext); opacity: .5; }

  .rg-field { margin-bottom: 10px; }
  .rg-row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }

  .rg-btn {
    width: 100%; height: 44px; margin-top: 14px; border: none; border-radius: 10px;
    background: var(--primary); color: #fff;
    font-size: 13px; font-weight: 600; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    gap: 6px; transition: opacity .18s;
    font-family: 'Inter', sans-serif;
  }
  .rg-btn:hover:not(:disabled) { opacity: .85; }
  .rg-btn:disabled { opacity: .35; cursor: not-allowed; }

  .rg-footer { text-align: center; margin-top: 14px; font-size: 12px; color: var(--subtext); }
  .rg-footer span { color: var(--primary); cursor: pointer; font-weight: 500; }
  .rg-footer span:hover { text-decoration: underline; }

  .rg-otp-label { font-size: 12px; color: var(--subtext); text-align: center; margin-bottom: 10px; }

  .rg-otp-boxes { display: flex; gap: 8px; justify-content: center; margin-bottom: 8px; }
  .rg-otp-boxes input {
    width: 42px; height: 50px;
    border: 1px solid var(--hover); border-radius: 10px;
    text-align: center; font-size: 20px; font-weight: 600;
    color: var(--text); background: var(--hover);
    outline: none; -moz-appearance: textfield;
    transition: border-color .18s, background .18s;
    font-family: 'Inter', sans-serif;
  }
  .rg-otp-boxes input::-webkit-outer-spin-button,
  .rg-otp-boxes input::-webkit-inner-spin-button { -webkit-appearance: none; }
  .rg-otp-boxes input:focus { border-color: var(--buy); background: var(--background); }

  .rg-resend { text-align: center; font-size: 11px; color: var(--subtext); opacity: .7; }
  .rg-resend span { color: var(--primary); cursor: pointer; opacity: 1; font-weight: 500; }
  .rg-resend span:hover { text-decoration: underline; }

  @media (max-width: 400px) {
    .rg-box { padding: 22px 16px 18px; }
    .rg-row { grid-template-columns: 1fr; gap: 0; }
  }
`;

export default function Register() {
  const [backend, setBackend] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [form, setForm] = useState({ name: "", mobile: "", password: "", confPassword: "", refcode: "" });

  useEffect(() => {
    const id = "rg-style";
    if (!document.getElementById(id)) {
      const s = document.createElement("style"); s.id = id; s.textContent = S;
      document.head.appendChild(s);
    }
  }, []);

  useEffect(() => {
    (async () => { const b = await new Backend().init(); setBackend(b); })();
  }, []);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleOtp = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const n = [...otp]; n[i] = val; setOtp(n);
    if (val && i < 5) document.getElementById(`o${i + 1}`)?.focus();
  };

  const handleOtpKey = (i, e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) document.getElementById(`o${i - 1}`)?.focus();
  };

  const submit = useCallback(async () => {
    if (!otpSent) {
      if (!form.name.trim() || !form.mobile.trim() || !form.password.trim() || !form.confPassword.trim())
        return toast.error("All fields are required");
      if (form.password !== form.confPassword)
        return toast.error("Passwords do not match");
    }
    const otpVal = otp.join("");
    if (otpSent && otpVal.length < 6) return toast.error("Enter 6-digit OTP");

    setLoading(true);
    try {
      const r = await backend.register({
        server: window.SERVER, name: form.name.trim(), mobile: form.mobile.trim(),
        password: form.password, refcode: form.refcode, otp: otpVal,
      });
      if (r.error === "False") {
        toast.success(r.message);
        if (!otpSent) setOtpSent(true);
        else navigate("/login");
      } else {
        toast.error(r.message || "Registration failed");
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [form, otp, otpSent, backend, navigate]);

  return (
    <div className="rg">
      <div className="rg-box">

        <div className="rg-head">
          <img src={window.LOGO} alt="logo" />
          <h2>{otpSent ? "Verify OTP" : "Create Account"}</h2>
          <p>{otpSent ? `Code sent to ${form.mobile}` : "Start your trading journey"}</p>
        </div>

        <div className="rg-steps">
          <div className={`rg-dot ${!otpSent ? "on" : ""}`} />
          <div className={`rg-dot ${otpSent ? "on" : ""}`} />
        </div>

        {!otpSent ? (
          <>
            <div className="rg-field">
              <label className="rg-label">Full Name</label>
              <input className="rg-input" name="name" value={form.name} onChange={handle} placeholder="Enter your name" />
            </div>
            <div className="rg-row">
              <div className="rg-field">
                <label className="rg-label">Mobile</label>
                <input className="rg-input" name="mobile" type="number" value={form.mobile} onChange={handle} placeholder="Mobile no." />
              </div>
              <div className="rg-field">
                <label className="rg-label">Broker Code</label>
                <input className="rg-input" name="refcode" value={form.refcode} onChange={handle} placeholder="Optional" />
              </div>
            </div>
            <div className="rg-row">
              <div className="rg-field">
                <label className="rg-label">Password</label>
                <input className="rg-input" name="password" type="password" value={form.password} onChange={handle} placeholder="Password" />
              </div>
              <div className="rg-field">
                <label className="rg-label">Confirm</label>
                <input className="rg-input" name="confPassword" type="password" value={form.confPassword} onChange={handle} placeholder="Confirm" />
              </div>
            </div>
          </>
        ) : (
          <>
            <p className="rg-otp-label">Enter the 6-digit code</p>
            <div className="rg-otp-boxes">
              {otp.map((d, i) => (
                <input key={i} id={`o${i}`} type="number" maxLength={1} value={d}
                  onChange={(e) => handleOtp(i, e.target.value.slice(-1))}
                  onKeyDown={(e) => handleOtpKey(i, e)}
                  autoFocus={i === 0} />
              ))}
            </div>
            <p className="rg-resend">
              Didn't get it? <span onClick={() => { setOtpSent(false); setOtp(["", "", "", "", "", ""]); }}>Resend</span>
            </p>
          </>
        )}

        <button className="rg-btn" disabled={loading} onClick={submit}>
          {loading ? <Spinner size="sm" /> : otpSent ? "Verify & Create Account" : "Send OTP"}
        </button>

        <div className="rg-footer">
          Already have an account? <span onClick={() => navigate("/login")}>Login</span>
        </div>
      </div>
    </div>
  );
}
